// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"11":"map-content","478":"resort-list"}[chunkId] + "." + __webpack_require__.h() + ".css";
};